import { combineReducers } from "redux";
import UserReducer from "./user/userReducer";
import ConnectionReducer from "./connection/connectionReducer";
import ProfileReducer from "./profile/profileReducer";
import ProfileUploadImageReducer from "./profile/profileUploadReducer";
import SignupReducer from "./signup/signupReducer";
import ConnectionReceivedReducer from "./connection/connectionReceivedReducer";
import ConnectionSendedReducer from "./connection/connectionSendedReducer";
import getEntityReducer from "./entities/get-entities-reducer";
import CreateEntityReducer from "./entities/create-entities-reducer";
import ProductReducer from "./products/productReducer";
import CreateProductReducer from "./products/createProductReducer";
import DeleteProductReducer from "./products/deleteProductReducer";
import UpdateProductReducer from "./products/updateProductReducer";

import GroupReducer from "./groups/groupReducer";
import CreateGroupReducer from "./groups/createGroupReducer";
import DeleteGroupReducer from "./groups/deleteGroupReducer";
import UpdateGroupReducer from "./groups/updateGroupReducer";

import EntitiesReducer from "./entities/get-entities-reducer";
import CreatedEntitiesReducer from "./entities/create-entities-reducer";
import DeletedEntitiesReducer from "./entities/delete-entities-reducer";
import UpdatedEntitiesReducer from "./entities/update-entity-reducer";

import SearcherReducer from "./searchers/SearcherReducer";
import CreateSearcherReducer from "./searchers/createSearcherReducer";
import DeleteSearcherReducer from "./searchers/deleteSearcherReducer";
import UpdateSearcherReducer from "./searchers/updateSearcherReducer";
import UniversitiesReducer from "./universities/SearcherReducer";
import UpdateUniversityReducer from "./universities/updateSearcherReducer";
import DeleteUniversityReducer from "./universities/deleteUniversityReducer";
import CreateUniversityReducer from "./universities/createUniversityReducer";
import ActorTypeReducer from "./actorTypes/actorTypeReducer";
import CommonsReducer from "./commons/CommonReducer";
import CreateCommonReducer from "./commons/createCommonReducer";
import DeleteCommonReducer from "./commons/deleteCommonReducer";
import UpdateCommonReducer from "./commons/updateCommonReducer";
import CreateActorTypeReducer from "./actorTypes/createActorTypeReducer";
import UpdateActorTypeReducer from "./actorTypes/updateActorTypeReducer";
import DeleteActorTypeReducer from "./actorTypes/deleteActorTypeReducer";
import ActorTypeByIdReducer from "./actorTypes/getActorTypeByIdReducer";
import MeDependenciesReducer from "./entities/get-me-entities-dependency-reducer";
import getMeGroupsReducer from "./groups/getMeGroups";
import ProjectsReducer from "./projects/ProjectReducer";
import CreateProjectReducer from "./projects/createProjectReducer";
import DeleteProjectReducer from "./projects/deleteProjectReducer";
import UpdateProjectReducer from "./projects/updateProjectReducer";
import ProjectsStatusReducer from "./projects/getProjectStatusReducer";
import AnnouncementReducer from "./announcements/announcementReducer";
import CreateAnnouncementReducer from "./announcements/createAnnouncementReducer";
import UpdateAnnouncementReducer from "./announcements/updateAnnouncementReducer";
import DeleteAnnouncementReducer from "./announcements/deleteAnnouncementReducer";
import CapacitiesTypeReducer from "./capacitiesTypes/capacitiesTypeReducer";
import CreateCapacitiesTypeReducer from "./capacitiesTypes/createCapacitiesTypeReducer";
import UpdateCapacitiesTypeReducer from "./capacitiesTypes/updateCapacitiesTypeReducer";
import DeleteCapacitiesTypesReducer from "./capacitiesTypes/deleteCapacitiesTypeReducer";
import CommonsCapacitiesReducer from "./commonsCapacities/CommonsCapacitiesReducer";
import CreateCommonCapacitiesReducer from "./commonsCapacities/createCommonsCapacitiesReducer";
import UpdateCommonCapacitiesReducer from "./commonsCapacities/updateCommonsCapacitiesReducer";
import DeleteCommonCapacitiesReducer from "./commonsCapacities/deleteCommonsCapacitiesReducer";
import GetUniversityReducer from "./universities/getUniversityReducer";
import GetSearcherReducer from "./searchers/getSearcherReducer";
import SearchUserReducer from "./users/searchUserReducer";
import CreateUserReducer from "./users/createUserReducer";
import UpdateUserReducer from "./users/updateUserReducer";
import DeleteUserReducer from "./users/deleteUserReducer";
import UsersReducer from "./users/UserReducer";
import RolesReducer from "./roles/SearcherReducer";
import ShowModalImportReducer from "./import/showModalImportReducer";
import ImportFromXlsxReducer from "./import/importFromXlsxReducer";
import ImportValidationResultReducer from "./import/importvalidationReducer";
import ExecuteImportReducer from "./import/executeImportReducer";
import AnnouncementUploadImageReducer from "./announcements/upload-image-announcementReducer";
import getAnalyticsReducer from "./analytics/getAnalyticsReducer";
import ShowModalPreferencesReducer from "./preferences/preferencesReducer";
import EventsReducer from "./events/eventReducer";
import CreateEventReducer from "./events/createEventReducer";
import DeleteEventReducer from "./events/deleteEventReducer";
import UpdateEventReducer from "./events/updateEventReducer";
import EventUploadImageReducer from "./events/upload-image-eventReducer";

const RootReducer = combineReducers({
  showModalImport: ShowModalImportReducer,
  showModalPreferences: ShowModalPreferencesReducer,
  analytics: getAnalyticsReducer,
  importValidationResult: ImportValidationResultReducer,
  executeImport: ExecuteImportReducer,
  importFromXlsx: ImportFromXlsxReducer,
  connection: ConnectionReducer,
  received: ConnectionReceivedReducer,
  sendeds: ConnectionSendedReducer,
  user: UserReducer,
  profile: ProfileReducer,
  entities: EntitiesReducer,
  createdEntities: CreatedEntitiesReducer,
  updatedEntities: UpdatedEntitiesReducer,
  deletedEntities: DeletedEntitiesReducer,
  dependencies: MeDependenciesReducer,
  products: ProductReducer,
  createdProduct: CreateProductReducer,
  updatedProduct: UpdateProductReducer,
  deletedProduct: DeleteProductReducer,
  groups: GroupReducer,
  createdGroup: CreateGroupReducer,
  updatedGroup: UpdateGroupReducer,
  deletedGroup: DeleteGroupReducer,
  myGroups: getMeGroupsReducer,
  searchers: SearcherReducer,
  searcher: GetSearcherReducer,
  createdSearcher: CreateSearcherReducer,
  updatedSearcher: UpdateSearcherReducer,
  deletedSearcher: DeleteSearcherReducer,
  users: UsersReducer,
  searchsUsers: SearchUserReducer,
  roles: RolesReducer,
  createdUser: CreateUserReducer,
  updatedUser: UpdateUserReducer,
  deletedUser: DeleteUserReducer,
  actorTypes: ActorTypeReducer,
  createdActorTypes: CreateActorTypeReducer,
  updatedActorTypes: UpdateActorTypeReducer,
  deletedActorTypes: DeleteActorTypeReducer,
  getActorType: ActorTypeByIdReducer,
  commons: CommonsReducer,
  createdCommon: CreateCommonReducer,
  updatedCommon: UpdateCommonReducer,
  deletedCommon: DeleteCommonReducer,
  commonsCapacities: CommonsCapacitiesReducer,
  createdCommonsCapacities: CreateCommonCapacitiesReducer,
  updatedCommonsCapacities: UpdateCommonCapacitiesReducer,
  deletedCommonsCapacities: DeleteCommonCapacitiesReducer,
  announcements: AnnouncementReducer,
  createdAnnouncement: CreateAnnouncementReducer,
  updatedAnnouncement: UpdateAnnouncementReducer,
  deletedAnnouncement: DeleteAnnouncementReducer,
  announcementImage: AnnouncementUploadImageReducer,
  events: EventsReducer,
  createdEvent: CreateEventReducer,
  updatedEvent: UpdateEventReducer,
  deletedEvent: DeleteEventReducer,
  eventImage: EventUploadImageReducer,
  universities: UniversitiesReducer,
  university: GetUniversityReducer,
  createdUniversity: CreateUniversityReducer,
  updatedUniversity: UpdateUniversityReducer,
  deletedUniversity: DeleteUniversityReducer,
  projects: ProjectsReducer,
  projectsStatus: ProjectsStatusReducer,
  createdProject: CreateProjectReducer,
  updatedProject: UpdateProjectReducer,
  deletedProject: DeleteProjectReducer,
  capacitiesTypes: CapacitiesTypeReducer,
  createdCapacitiesType: CreateCapacitiesTypeReducer,
  updatedCapacitiesType: UpdateCapacitiesTypeReducer,
  deletedCapacitiesType: DeleteCapacitiesTypesReducer,
  entityCreated: CreateEntityReducer,
  upload: ProfileUploadImageReducer,
  signup: SignupReducer,
});

export default RootReducer;
